import { isSmartPhone } from '../../utilities/helper';
import useTheme from '../../utilities/hooks/theme';
import './index.css';

const MatchCardWrapper = ({ iconSrc, title, children, onClickHandler }: any) => {
  const { DashboardTheme: theme } = useTheme();
  const viewAllTextStyle = {
    color: theme.cricketMatchCardViewAllText
  };
  return (
    <div className={isSmartPhone ? 'match_card_wrapper_mWeb' : 'match_card_wrapper'}>
      <div className="match_card_top">
        <div className="match_card_heading">
          <img src={iconSrc} className="matchCard__icon" />
          <span className="title_1">{title}</span>
        </div>
        <div
          className={isSmartPhone ? 'match_card_view_all_txt_mWeb' : 'match_card_view_all_txt'}
          onClick={onClickHandler}
          style={viewAllTextStyle}>
          View all
        </div>
      </div>
      <div className="match_card_holder">{children}</div>
    </div>
  );
};

export default MatchCardWrapper;
